import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiPhone, FiMail, FiMapPin } = FiIcons;

function Footer() {
  return (
    <footer className="glass-card mt-20">
      <div className="container py-12">
        <div className="grid md:grid-cols-3 gap-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h3 className="text-2xl font-bold mb-4">Kumarana Hotel</h3>
            <p className="text-white/80 mb-4">
              Your gateway to the heritage and hospitality of Sabaragamuwa Province. 
              Experience superior accommodation and authentic cuisine at the historic Panamure Junction.
            </p>
            <div className="space-y-2">
              <div className="flex items-center gap-2 text-sm">
                <SafeIcon icon={FiMapPin} className="text-blue-300" />
                <span className="text-white/80">Panamure Junction, Main Road, Kolonna</span>
              </div>
              <div className="flex items-center gap-2 text-sm">
                <SafeIcon icon={FiPhone} className="text-blue-300" />
                <a href="tel:076-8727112" className="text-white/80 hover:text-white">076-8727112</a>
              </div>
              <div className="flex items-center gap-2 text-sm">
                <SafeIcon icon={FiMail} className="text-blue-300" />
                <a href="mailto:info@kumarana-panamure.com" className="text-white/80 hover:text-white">info@kumarana-panamure.com</a>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.1 }}
          >
            <h4 className="text-xl font-semibold mb-4">Services</h4>
            <ul className="space-y-2 text-white/80">
              <li><a href="#rooms" className="hover:text-white transition-colors">Superior Bungalow Rooms</a></li>
              <li><a href="#restaurant" className="hover:text-white transition-colors">Restaurant & Buffet</a></li>
              <li><a href="/lunch-stop" className="hover:text-white transition-colors">Group Lunch Stops</a></li>
              <li><a href="#heritage" className="hover:text-white transition-colors">Heritage Tours</a></li>
              <li><span>Driver Lounge Facilities</span></li>
              <li><span>Day Use Rooms</span></li>
            </ul>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <h4 className="text-xl font-semibold mb-4">SLTDA Certification</h4>
            <div className="space-y-2 text-sm">
              <div className="glass-card p-3 rounded-lg">
                <div className="text-white/60">Registration:</div>
                <div className="font-mono text-blue-300">SLTDA/SQA/BUN/01295</div>
              </div>
              <div className="glass-card p-3 rounded-lg">
                <div className="text-white/60">License:</div>
                <div className="font-mono text-blue-300">BUN/2025/0075</div>
              </div>
              <div className="glass-card p-3 rounded-lg">
                <div className="text-white/60">Classification:</div>
                <div className="text-green-400 font-semibold">Superior Bungalow</div>
              </div>
            </div>
          </motion.div>
        </div>

        <motion.div
          className="border-t border-white/10 mt-8 pt-8 text-center"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.3 }}
        >
          <p className="text-white/60 flex items-center justify-center gap-2">
            © 2025 Kumarana Hotel & Restaurant. Designed and Created by Rajantha
          </p>
        </motion.div>
      </div>
    </footer>
  );
}

export default Footer;